import { Link } from "react-router-dom"
import "./productRow.css"

export function ProductRow({ product }) {
    return (
        <table className="products-table">
            <tbody>
                <tr className="mt-3">
                    <td>
                        <div className="d-flex align-items-center ps-3 gap-3">
                            <div className="d-flex align-items-center admin-product-image">
                                <img src={product.image} width={30} alt="" />
                            </div>
                            <div className="admin-product-title">{product.title}</div>
                        </div>
                    </td>
                    <td>{product.category.charAt(0).toUpperCase() + product.category.slice(1)}</td>
                    <td>${product.regularPrice}</td>
                    <td>{product.salePrice ? "$" + product.salePrice : ""}</td>
                    <td>{product.stock}</td>
                    <td className="text-end px-3">
                        <Link
                            to={`/admin/products/${product._id}/edit`}
                            className="custom-btn primary text-center rounded-1 px-4 py-1">
                                Edit
                        </Link>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}